export default __webpack_public_path__ + "static/portfolio_gallery_7-7cd7ad975c295b9b7019c28c994efecf.jpg";